export const serializedMCQData = mcqData => {
  const serializedMcq = {
    id: mcqData.data.id,
    text: mcqData.data.attributes.text,
    options: [],
    point: mcqData.data.attributes.points,
    multipleCorrectAnswers: mcqData.data.attributes.multiple_correct,
    format: mcqData.data.attributes.format,
  };

  mcqData.included.forEach(option => {
    serializedMcq.options.push({
      id: option.id,
      text: option.attributes.text,
      order: option.attributes.order,
    });
  });
  serializedMcq.options.sort((a, b) => a.order - b.order);

  return serializedMcq;
};
